<template>
  <v-container class="product-container">
    <v-row v-if="loading" justify="center">
      <RingLoader :color="'rgba(238, 117, 4, 0.993)'" />
    </v-row>
    <v-row v-else>
      <!-- Side bar -->
      <v-col sm="12" md="3" lg="3" xl="2" class="">
        <div class="filterClassPDI sidebar mx-auto">
          <v-container class="pa-0 pb-3">
            <v-row>
              <v-col cols="12" class="pa-2">
                <p class="title-filter">
                  <strong class="titleStyle">Filtrar resultados</strong>
                </p>
              </v-col>
            </v-row>

            <!-- PDI Filter -->
            <v-row v-if="!pdiPage">
              <v-col cols="12" class="pa-2">
                <v-list class="filterClassPDI">
                  <v-list-item>
                    <template>
                      <v-list-item-action>
                        <v-checkbox
                          v-model="filter.pdi"
                          @change="search()"
                          color="primary"
                        >
                        </v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="pa-0">
                        <v-list-item-title>
                          <v-tooltip top max-width="400">
                            <template v-slot:activator="{ on }">
                              <div class="pdiImage" v-on="on">
                                <img
                                  class="img"
                                  src="./../../assets/pdi_logo.png"
                                />
                              </div>
                            </template>
                            <span>
                              Mediante nuestras Soluciones PDI buscamos a través
                              de la disponibilidad y entrega inmediata de una
                              amplia cantidad de productos y componentes
                              aseguramos que cualquier plan o proyecto se
                              desarrolle sin contratiempos, encontrando todo lo
                              relacionado
                            </span>
                          </v-tooltip>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <!-- Promo Filter -->
            <v-row v-if="!isPromoPage">
              <v-col cols="12" class="pa-2">
                <v-list class="filterClassPDI">
                  <v-list-item>
                    <template>
                      <v-list-item-action>
                        <v-checkbox
                          v-model="filter.promo"
                          @change="search()"
                          color="primary"
                        >
                        </v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>Promoción</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <!-- Categories filter -->
            <v-row v-if="showCategory">
              <v-col cols="12" class="pa-2">
                <v-list
                  dense
                  color="primary"
                  class="filterClass theme--dark white--text"
                >
                  <v-list-group v-model="showCategoryFilter">
                    <template color="primary" v-slot:activator>
                      <v-list-item-title class="vlistContent">
                        Categoría
                      </v-list-item-title>
                    </template>
                    <v-list dense class="scrollSubList">
                      <v-list-item
                        v-for="category in filterCategories"
                        :key="category.id"
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-subtitle max-width="200">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <a
                                    v-on="on"
                                    class="vlistContentCharacteristic"
                                    @click="productCategory(category)"
                                    v-text="category.name"
                                  >
                                  </a>
                                </template>

                                <span>
                                  {{ category.name }}
                                </span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>

            <!-- Brands filter -->
            <v-row>
              <v-col cols="12" class="pa-2">
                <v-list
                  dense
                  color="primary"
                  class="filterClass theme--dark white--text"
                >
                  <v-list-group>
                    <template color="primary" v-slot:activator>
                      <v-list-item-title class="vlistContent">
                        Marcas
                      </v-list-item-title>
                    </template>

                    <v-list dense class="scrollSubList">
                      <v-list-item v-for="brand in brands" :key="brand.id">
                        <template>
                          <v-list-item-action>
                            <v-checkbox
                              color="primary"
                              v-model="brand.filterOn"
                              @change="filtrarBrands()"
                            >
                            </v-checkbox>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title v-text="brand.name">
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>

            <!-- common names filter -->
            <v-row v-show="noCategory != true">
              <v-col cols="12" class="pa-2">
                <v-list
                  dense
                  color="primary"
                  class="filterClass theme--dark white--text"
                >
                  <v-list-group>
                    <template color="primary" v-slot:activator>
                      <v-list-item-title class="vlistContent">
                        Nombre común
                      </v-list-item-title>
                    </template>

                    <v-list dense class="scrollSubList">
                      <v-list-item
                        v-for="commonName in commonNames"
                        :key="commonName.name"
                      >
                        <v-list-item-action>
                          <v-checkbox
                            color="primary"
                            v-model="commonName.filterOn"
                            @change="filtrarCommonName()"
                          >
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-list-item-title
                                v-on="on"
                                v-text="commonName.name"
                              >
                              </v-list-item-title>
                            </template>

                            <span>
                              {{ commonName.name }}
                            </span>
                          </v-tooltip>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>

            <!-- product Type filter -->
            <v-row v-if="communNameSelected">
              <v-col cols="12" class="pa-2">
                <v-list
                  dense
                  color="primary"
                  class="filterClass theme--dark white--text"
                >
                  <v-list-group>
                    <template color="primary" v-slot:activator>
                      <v-list-item-title class="vlistContent">
                        Tipo de producto
                      </v-list-item-title>
                    </template>

                    <v-list dense class="scrollSubList">
                      <v-list-item
                        v-for="productType in productTypes"
                        :key="productType.Id"
                      >
                        <template>
                          <v-list-item-action>
                            <v-checkbox
                              color="primary"
                              v-model="productType.filterOn"
                              @change="filtrarProductType(productType)"
                            >
                            </v-checkbox>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-list-item-title
                                  v-on="on"
                                  v-text="productType.name"
                                >
                                </v-list-item-title>
                              </template>

                              <span>
                                {{ productType.name }}
                              </span>
                            </v-tooltip>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>

            <!-- Caracteristics filter -->
            <v-row v-if="communNameSelected">
              <v-col cols="12" class="pa-2">
                <v-list
                  dense
                  color="primary"
                  class="filterClass theme--dark white--text"
                >
                  <v-list-group>
                    <template color="primary" v-slot:activator>
                      <v-list-item-title class="vlistContent">
                        Características
                      </v-list-item-title>
                    </template>

                    <v-list
                      v-for="(characteristic, index) in char"
                      :key="index"
                      color="secondary"
                      class="theme--dark white--text"
                    >
                      <v-list-group>
                        <template color="primary" v-slot:activator>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-list-item-title v-on="on" class="vlistContent">
                                {{ characteristic[0] }}
                              </v-list-item-title>
                            </template>

                            <span>
                              {{ characteristic[0] }}
                            </span>
                          </v-tooltip>
                        </template>

                        <v-list dense class="scrollSubList">
                          <v-list-item
                            v-for="item in characteristic[1]"
                            :key="item.characteristic"
                          >
                            <template>
                              <v-list-item-action>
                                <v-checkbox
                                  v-model="item.filterOn"
                                  @change="filtrarCharacteristics(item)"
                                  color="primary"
                                >
                                </v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-list-item-title
                                      v-on="on"
                                      v-text="item.value"
                                    >
                                    </v-list-item-title>
                                  </template>

                                  <span>
                                    {{ item.value }}
                                  </span>
                                </v-tooltip>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-list-group>
                    </v-list>
                  </v-list-group>
                </v-list>
              </v-col>
            </v-row>

            <!-- Reset Button-->
            <v-row>
              <v-col>
                <v-btn color="secondary" @click="resetFilter">
                  Borrar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>

      <!-- Plantilla De Producto -->
      <v-col sm="12" md="9" lg="9" xl="10" class="">
        <v-row justify="center">
          <v-col
            class="pa-0 pb-3"
            justify="center"
            v-for="(product, index) in products"
            :key="product.id"
          >
            <cardProduct
              :id="index"
              :product="product"
              :addShoppingCart="addShoppingCart"
            >
            </cardProduct>
          </v-col>
        </v-row>

        <br />
      </v-col>

      <br />

      <v-col cols="12" sm="12" md="3" lg="3" xl="2"></v-col>

      <v-col sm="12" md="9" lg="9" xl="10">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="1"></v-col>

            <v-col cols="10">
              <v-pagination
                v-model="page"
                @input="refreshProducts()"
                class="my-4"
                :length="pages"
              >
              </v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from "underscore";
import List from "./../../mixins/list";
import { RingLoader } from "vue-spinners-css";
import cardProduct from "./child_cardProduct.vue";

import {
  addProductCart,
  removeProductCart,
  updateProductCart,
} from "./../../utils/shoppingCart";

export default {
  name: "productShow",

  components: {
    cardProduct,
    RingLoader,
  },

  data() {
    return {
      showCategoryFilter: true,
      dialog: false,
      communNameSelected: false,
      parentCategory: {
        PDI: [],
        noPDI: [],
      },
      queryBase: "",
      show: false,
      showCategory: false,
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/",
      brands: [],
      idCategory: "",
      keyword: "",
      diccionario: {
        brands: [],
        productTypes: [],
        characteristics: [],
        commonNames: [],
        productos: [],
      },
      products: [],
      producto: [],
      categories: [],
      filterCategories: [],
      productTypes: [],
      characteristics: [],
      commonNames: [],
      offset: 0,
      limit: 24,
      page: 1,
      pages: 1,
      pdi: false,
      query: "",
      productsList: [],
      isPromoPage: true,
      filter: {
        pdi: false,
        promo: false,
        category: "",
        brands: [],
        characteristics: [],
        value: "",
        commonNames: [],
        productTypes: [],
        offset: 0,
        limit: 24,
      },
      oldFilter: {
        pdi: false,
        promo: false,
        category: "",
        brands: [],
        characteristics: [],
        value: "",
        commonNames: [],
        productTypes: [],
        offset: 0,
        limit: 24,
      },
      pdiPage: false,
      char: [],
      loading: false,
      noCategory: false,
    };
  },

  props: {
    sendSnack: { type: Function },
    updateShopingQuantity: { type: Function },
  },

  mixins: [List],

  methods: {
    getExistence: function (item) {
      var baseURL = "https://market.risoul.com.mx/api/product/existencias";

      this.$http({
        method: "get",
        url: `${baseURL}/${item.itemId}`,
      }).then(
        (response) => {
          item.existencias = response.body.existencias;
          item.showExistencias = true;
        },
        (error) => {
          this.sendSnack(
            `Hubo un problema al obtener la existencia del producto`,
          );
          console.error(error);
        },
      );
    },

    image: function (name) {
      var image = name.split(" ").join("+");
      image = image.split("#").join("%23");
      var url = this.url + image;
      return url;
    },

    productName: function (name) {
      if (name.length > 70) name = `${name.substring(0, 70)}...`;
      return name;
    },

    productCategory: function (category) {
      this.filter.category = category.id;
      this.$router.push({
        path: `/products/category/${category.name}`,
        query: {
          filter: JSON.stringify(this.filter),
        },
      });
    },

    productsInicialize: function () {
      var queryRoute = this.$route.query;
      var page = this.$route.name;

      this.isPromoPage = page == "promo" ? true : false;

      if (queryRoute.pdi == 1) {
        this.filter.pdi = true;
      }

      if (page == "PDIT3" || page == "PDIT4") {
        this.filter.pdi = true;
        this.pdiPage = true;
      }

      if (queryRoute.idCategory != null) {
        this.filter.category = queryRoute.idCategory;
      }

      if (queryRoute.brandId != null) {
        this.filter.brands.push(queryRoute.brandId);
      }

      if (queryRoute.value != null) {
        this.filter.value = queryRoute.value;
      }

      if (this.isPromoPage) {
        this.filter.promo = true;
      }

      if (queryRoute.filter != null) {
        this.filter = JSON.parse(queryRoute.filter);
      }

      this.search();
    },

    search: function () {
      this.loading = true;
      const vm = this;
      this.$http
        .post("product/filter", this.filter)
        .then(
          (res) => {
            const data = res.body.data;

            // Actualizar productos y diccionarios
            this.productsList = data.products;
            this.diccionario.productos = data.products;
            this.products = this.productsList.slice(this.offset, this.limit);

            // Actualizar categorías
            this.categories = data.categories;

            // Actualizar características y diccionarios
            this.characteristics = data.characteristics;
            vm.char = Object.entries(this.characteristics);
            this.diccionario.characteristics = vm.char;

            // Actualizar marcas y diccionarios
            this.brands = data.brands;
            this.diccionario.brands = data.brands;

            // Actualizar tipos de producto y diccionarios
            this.productTypes = data.productTypes;
            this.diccionario.productTypes = data.productTypes;

            // Actualizar nombres comunes y diccionarios
            this.commonNames = data.commonNames;
            this.diccionario.commonNames = data.commonNames;

            // Filtrar categorías
            var listCategories = this.categories;
            this.filterCategories = _.sortBy(listCategories, "name");

            this.filterCategories = _.filter(
              this.filterCategories,
              function (category) {
                return category.pdi == vm.filter.pdi;
              },
            );

            this.filterCategories =
              this.isPromoPage || this.$route.name == "productShowBrand"
                ? _.filter(this.filterCategories, function (category) {
                    return category.parentId == null;
                  })
                : this.filterCategories;

            this.showCategory = this.categories.length > 0;
            this.pages = Math.ceil(this.productsList.length / 24);
            this.loading = false;

            // Verificar si no hay categoría
            if (
              this.categories.length == 1 &&
              this.categories.filter((cat) => cat.name == "SIN CATEGORÍA")
                .length == 1
            ) {
              this.noCategory = true;
            } else {
              this.noCategory = false;
            }
          },
          (error) => {
            this.sendSnack(
              error.message ||
                "Hubo un problema al obtener la lista de productos",
            );
            this.loading = false;
          },
        )
        .finally(() => {
          this.loading = false;
        });
    },

    /*
     * Filtrado de Marcas
     * Filtra las marcas obtenidas desde la api por medio de TS.
     */
    filtrarBrands: function () {
      var brands = this.brands.filter((b) => {
        return b.filterOn == true;
      });
      this.filter.brands = _.pluck(brands, "id");
      this.filtering();
    },

    /*
     * Filtrado de Nombres Comunes
     * Filtra los nombres comunes obtenidos desde la api por medio de TS.
     */
    filtrarCommonName: function () {
      this.filter.commonNames = this.commonNames.filter((b) => {
        return b.filterOn == true;
      });
      this.filter.commonNames = _.pluck(this.filter.commonNames, "name");
      this.filtering();
    },

    /*
     * Filtrado de Tipo de Productos
     * Filtra el tipo de productos obtenidos desde la api por medio de TS y se muestra hasta
     * que se selecciona un nombre común.
     */
    filtrarProductType: function (item) {
      var vm = this;
      if (item.filterOn) {
        vm.filter.productTypes.push(item.id);
      } else {
        for (let i = 0; i < vm.filter.productTypes.length; i++) {
          if (vm.filter.productTypes[i] == item.id)
            vm.filter.productTypes.splice(i, 1);
        }
      }

      vm.filtering();
    },

    /*
     * Filtrado de Características
     * Filtra las caracteristicas obtenidas desde la api por medio de TS y se muestra hasta
     * que se selecciona un nombre común.
     */
    filtrarCharacteristics: function (item) {
      var vm = this;
      if (item.filterOn) {
        vm.filter.characteristics.push(item.characteristic);
      } else {
        for (let i = 0; i < vm.filter.characteristics.length; i++) {
          if (vm.filter.characteristics[i] == item.characteristic)
            vm.filter.characteristics.splice(i, 1);
        }
      }
      this.filtering();
    },

    filtering: function () {
      const vm = this;
      const filtro = vm.filter;
      const oldFilter = vm.oldFilter;

      /*
       * Caso 1
       * Solo se filtro por las marcas.
       */
      if (filtro.brands.length > 0 && filtro.commonNames.length === 0) {
        vm.communNameSelected = false;

        if (!_.isEqual(oldFilter.brands, filtro.brands)) {
          let newCommunNameFilter = [];

          vm.productsList = _.filter(vm.diccionario.productos, (product) => {
            return vm.filter.brands.includes(product.brand.id);
          });

          _.map(vm.productsList, (product) => {
            const commonName = {
              name: product.commonName,
              filterOn: false,
            };
            newCommunNameFilter.push(commonName);
          });

          newCommunNameFilter = _.uniq(newCommunNameFilter, "name");
          this.commonNames = _.sortBy(newCommunNameFilter, "name");
        }
      } else if (filtro.brands.length === 0 && filtro.commonNames.length > 0) {
        /*
         * Caso 2
         * Solo se filtro por los nombres comunes.
         */
        vm.communNameSelected = true;

        if (!_.isEqual(oldFilter.commonNames, filtro.commonNames)) {
          let newBrands = [];
          let newProductType = [];
          let newCharacteristics = [];

          vm.productsList = _.filter(vm.diccionario.productos, (product) => {
            return vm.filter.commonNames.includes(product.commonName);
          });

          _.map(vm.productsList, (product) => {
            const brand = product.brand;
            brand.filterOn = false;
            newBrands.push(brand);

            const productType = product.productType;
            productType.filterOn = false;
            newProductType.push(productType);

            _.map(product.characteristics, (characteristic) => {
              if (characteristic.cvFilter) characteristic.filterOn = false;
              newCharacteristics.push(characteristic);
            });
          });

          newCharacteristics = _.uniq(newCharacteristics, "characteristic");
          newCharacteristics = _.groupBy(newCharacteristics, "name");
          newCharacteristics = _.filter(newCharacteristics, (x) => {
            const isTrue = _.map(x, (char) => char.cvFilter);
            return isTrue.includes(true);
          });

          const newcharacteristics = {};
          _.map(newCharacteristics, (charGroup) => {
            newcharacteristics[charGroup[0].name] = charGroup;
          });

          newBrands = _.uniq(newBrands, "id");
          newBrands = _.map(newBrands, (brand) => {
            if (filtro.brands.includes(brand.id)) {
              brand.filterOn = true;
            }
            return brand;
          });

          vm.char = Object.entries(newcharacteristics);
          vm.brands = _.sortBy(newBrands, "name");
          newProductType = _.uniq(newProductType, "id");
          vm.productTypes = _.sortBy(newProductType, "name");
        }
      } else if (filtro.brands.length > 0 && filtro.commonNames.length > 0) {
        /*
         * Caso 3
         * Modificaciones cuando alguno de los filtros anteriores está activo.
         */
        this.communNameSelected = true;

        // Filtrado por nombre común
        if (!_.isEqual(oldFilter.commonNames, filtro.commonNames)) {
          let newBrands = [];
          let newProductType = [];
          let newCharacteristics = [];

          vm.productsList = _.filter(vm.diccionario.productos, (product) => {
            return (
              vm.filter.commonNames.includes(product.commonName) &&
              vm.filter.brands.includes(product.brand.id)
            );
          });

          _.map(vm.productsList, (product) => {
            const brand = product.brand;
            brand.filterOn = false;
            newBrands.push(brand);

            const productType = product.productType;
            productType.filterOn = false;
            newProductType.push(productType);

            _.map(product.characteristics, (characteristic) => {
              if (characteristic.cvFilter) characteristic.filterOn = false;
              newCharacteristics.push(characteristic);
            });
          });

          newBrands =
            filtro.commonNames.length === 0
              ? vm.diccionario.brands
              : _.uniq(newBrands, "id");

          newBrands = _.map(newBrands, (brand) => {
            if (filtro.brands.includes(brand.id)) {
              brand.filterOn = true;
            }
            return brand;
          });

          newCharacteristics = _.uniq(newCharacteristics, "characteristic");
          newCharacteristics = _.map(newCharacteristics, (characteristic) => {
            characteristic.filterOn = this.filter.characteristics.includes(
              characteristic.characteristic,
            )
              ? true
              : false;
            return characteristic;
          });
          newCharacteristics = _.groupBy(newCharacteristics, "name");
          newCharacteristics = _.filter(newCharacteristics, (x) => {
            const isTrue = _.map(x, (char) => char.cvFilter);
            return isTrue.includes(true);
          });

          const newcharacteristics = {};
          _.map(newCharacteristics, (charGroup) => {
            newcharacteristics[charGroup[0].name] = charGroup;
          });

          vm.char = Object.entries(newcharacteristics);
          vm.brands = _.sortBy(newBrands, "name");
          newProductType = _.uniq(newProductType, "id");
          vm.productTypes = _.sortBy(newProductType, "name");
        }

        // Filtrado por marca
        else if (!_.isEqual(oldFilter.brands, filtro.brands)) {
          let newCommunNameFilter = [];
          let newCharacteristics = [];

          vm.productsList = _.filter(vm.diccionario.productos, (product) => {
            return (
              vm.filter.brands.includes(product.brand.id) &&
              vm.filter.commonNames.includes(product.commonName)
            );
          });

          _.map(vm.productsList, (product) => {
            const commonName = {
              name: product.commonName,
              filterOn: false,
            };
            _.map(product.characteristics, (characteristic) => {
              if (characteristic.cvFilter) characteristic.filterOn = false;
              newCharacteristics.push(characteristic);
            });
            newCommunNameFilter.push(commonName);
          });

          newCommunNameFilter = _.uniq(newCommunNameFilter, "name");
          newCommunNameFilter = _.map(newCommunNameFilter, (commonName) => {
            if (filtro.commonName.includes(commonName)) {
              commonName.filterOn = true;
            }
            return commonName;
          });

          newCharacteristics = _.uniq(newCharacteristics, "characteristic");
          newCharacteristics = _.map(newCharacteristics, (characteristic) => {
            characteristic.filterOn = this.filter.characteristics.includes(
              characteristic.characteristic,
            )
              ? true
              : false;
            return characteristic;
          });
          newCharacteristics = _.groupBy(newCharacteristics, "name");
          newCharacteristics = _.filter(newCharacteristics, (x) => {
            const isTrue = _.map(x, (char) => char.cvFilter);
            return isTrue.includes(true);
          });

          const newcharacteristics = {};
          _.map(newCharacteristics, (charGroup) => {
            newcharacteristics[charGroup[0].name] = charGroup;
          });

          vm.char = Object.entries(newcharacteristics);
          this.commonNames = _.sortBy(newCommunNameFilter, "name");
        }
      } else {
        /*
         * Caso 4
         * Si no está seleccionado ninguno solo se reinician los filtros a los datos del diccionario
         */
        this.communNameSelected = false;
        this.commonNames = vm.diccionario.commonNames;
        this.brands = vm.diccionario.brands;
        vm.productsList = vm.diccionario.productos;
      }

      /*
       * Caso 5
       */
      if (vm.communNameSelected) {
        /*
         * Caso 5.1
         * Solo se filtra por uno más tipo de productos.
         */
        if (
          filtro.productTypes.length > 0 &&
          filtro.characteristics.length === 0
        ) {
          if (!_.isEqual(oldFilter.productTypes, filtro.productTypes)) {
            let newCharacteristics = [];

            vm.productsList = _.filter(vm.productsList, (product) => {
              return vm.filter.productTypes.includes(product.productType.id);
            });

            _.map(vm.productsList, (product) => {
              _.map(product.characteristics, (characteristic) => {
                if (characteristic.cvFilter) characteristic.filterOn = false;
                newCharacteristics.push(characteristic);
              });
            });

            newCharacteristics = _.uniq(newCharacteristics, "characteristic");
            newCharacteristics = _.map(newCharacteristics, (characteristic) => {
              characteristic.filterOn = this.filter.characteristics.includes(
                characteristic.characteristic,
              )
                ? true
                : false;
              return characteristic;
            });
            newCharacteristics = _.groupBy(newCharacteristics, "name");
            newCharacteristics = _.filter(newCharacteristics, (x) => {
              const isTrue = _.map(x, (char) => char.cvFilter);
              return isTrue.includes(true);
            });

            const newcharacteristics = {};
            _.map(newCharacteristics, (charGroup) => {
              newcharacteristics[charGroup[0].name] = charGroup;
            });

            vm.char = Object.entries(newcharacteristics);
          }
        } else if (
          /*
           * Caso 5.2
           * Solo se filtra por una o más características.
           */
          filtro.productTypes.length === 0 &&
          filtro.characteristics.length > 0
        ) {
          if (!_.isEqual(oldFilter.characteristics, filtro.characteristics)) {
            vm.productsList = _.filter(vm.productsList, (product) => {
              const isInFilter = _.map(product.characteristics, (char) =>
                filtro.characteristics.includes(char.characteristic)
                  ? true
                  : false,
              );

              return isInFilter.includes(true);
            });

            let newProductType = [];
            _.map(vm.productsList, (product) => {
              const productType = product.productType;
              productType.filterOn = false;
              newProductType.push(productType);
            });
            newProductType = _.uniq(newProductType, "id");
            vm.productTypes = _.sortBy(newProductType, "name");
          }
        } else if (
          /*
           * Caso 5.3
           * Se filtra por una o más características y tipos de producto.
           */
          filtro.productTypes.length > 0 &&
          filtro.characteristics.length > 0
        ) {
          if (!_.isEqual(oldFilter.productTypes, filtro.productTypes)) {
            vm.productsList = _.filter(vm.productsList, (product) => {
              return vm.filter.productTypes.includes(product.productType.id);
            });
          }

          if (!_.isEqual(oldFilter.characteristics, filtro.characteristics)) {
            vm.productsList = _.filter(vm.productsList, (product) => {
              const isInFilter = _.map(product.characteristics, (char) =>
                filtro.characteristics.includes(char.characteristic)
                  ? true
                  : false,
              );

              return isInFilter.includes(true);
            });
          }
        }
      } else {
        vm.filter.productTypes = [];
        vm.filter.characteristics = [];
      }

      vm.offset = 0;
      vm.limit = 24;
      vm.pages = Math.ceil(vm.productsList.length / 24);
      vm.products = vm.productsList.slice(vm.offset, vm.limit);
    },

    resetFilter: function () {
      const vm = this;

      // Reiniciar todos los filtros
      vm.filter.brands = [];
      vm.filter.characteristics = [];
      vm.filter.commonNames = [];
      vm.filter.productTypes = [];

      // Aplicar filtrado con filtros reiniciados
      vm.filtering();

      // Asegurarse de que todas las marcas y nombres comunes estén desmarcados
      vm.brands = vm.brands.map((brand) => {
        brand.filterOn = false;
        return brand;
      });

      vm.commonNames = vm.commonNames.map((cn) => {
        cn.filterOn = false;
        return cn;
      });
    },

    productDetail: function (sku) {
      return "#/productDetail/" + sku;
    },

    refreshProducts: function () {
      var offset = (this.page - 1) * 24;
      var limit = (this.page - 1) * 24 + 24;
      var products = this.productsList.slice(offset, limit);
      this.products = products;
      window.scrollTo(0, 0);
    },

    addShoppingCart: function (item) {
      var producto = {
        id: item.id,
        image: item.image,
        description: item.description,
        itemId: item.itemId,
        code: item.code,
        providerCode: item.providerCode,
        unit: item.unitType,
        quantity: item.quantity,
      };
      if (item.quantity > 0) {
        addProductCart(producto);
        this.sendSnack("Producto agregado con exito");
        this.updateShopingQuantity();
        item.quantity = 0;
      } else {
        this.product.quantity = 1;
        this.sendSnack(
          "Debes ingresar al menos 1 producto al carrito de compras",
        );
      }

      this.$forceUpdate();
    },

    removeShoppingCart: function (item) {
      removeProductCart(item.id);
      this.updateShopingQuantity();
    },

    updateProductCart: function (item) {
      var producto = {
        id: item.id,
        quantity: item.quantity,
      };
      updateProductCart(producto);
      this.updateShopingQuantity();
    },

    increase: function (item) {
      this.products[item].quantity++;
      this.$forceUpdate();
    },

    decrease: function (item) {
      if (this.products[item].quantity > 0) {
        this.products[item].quantity--;
        this.$forceUpdate();
      }
    },
  },

  computed: {},

  watch: {
    "$route.query": function () {
      this.$router.go();
    },

    offset: function () {
      this.initialize(this.$route.query);
    },

    pdi: function () {
      this.products = [];
      this.initialize(this.$route.query);
    },
  },

  created: function () {
    this.queryBase = `offset=${this.offset}&limit=${this.limit}&pdi=${this.pdi}`;
    this.keyword = this.$route.query;
    this.productsInicialize();
  },

  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.v-list-item {
  min-height: 27px !important;
  padding: 0 0 0 10px !important;
}

.v-input--selection-controls
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple:before {
  transform: scale(0.9);
}

.v-list {
  padding: 2px 0;
}

.v-list--dense .v-list-item .v-list-item__content,
.v-list-item--dense .v-list-item__content {
  padding: 0px;
}

.v-list-item__action {
  margin: 2px;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 28px;
}

.v-btn.v-size--default,
.v-btn.v-size--large {
  font-size: 1.3rem;
}

.existenciasClass {
  transform: scale(0.8);
}

.existenciasClass ::v-deep input {
  width: 62px;
  text-align: center;
}
.productContainer {
  max-width: 1199px;
}

.productTitle {
  height: 120px;
}

.titleStyle {
  font-size: 24px;
  font-family: roboto;
}

.filterClass {
  width: 99%;
  background: #f7f7f7 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 0px 10px 10px 0px;
  opacity: 1;
}

.filterClassPDI {
  width: 98%;
  background: #f7f7f7 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 0px 10px 10px 0px;
  opacity: 1;
}

.vlistContentCharacteristic {
  background-color: white;
  /* color: rgb(0, 0, 0); */
  font-size: 12px;
  font-family: roboto;
}

.vlistContent {
  color: white;
  font-size: 16px;
  font-weight: bolder;
  font-family: roboto;
}

.img {
  height: 40px;
  width: auto;
  margin-left: 20px;
}

.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 150px;
  height: 200px;
}

.counterItem {
  text-align: center;
}

.scrollList {
  max-height: 600px;
  overflow-y: auto;
}

.scrollSubListParent {
  max-height: 500px;
  overflow-y: auto;
}

.scrollSubList {
  max-height: 250px;
  overflow-y: auto;
}

.sidebar {
  width: 230px;
  position: -webkit-sticky;
  position: sticky;
  top: -500px;
}

.countButton {
  height: 30px;
  width: 30px;
}

.itemDescription {
  font-size: 12px;
}

.padding {
  padding: 0px 16px 0 16px;
}

.paddingButton {
  padding: 0px;
}

.skuStyle {
  height: 88px;
}

.pdiImage {
  display: flex;
  justify-content: left;
  align-items: center;
  max-width: auto;
  height: 45px;
}

.title-filter {
  text-align: center;
  margin: 0;
}

@media (min-width: 960px) {
  .product-container {
    max-width: 980px;
  }
}

@media (min-width: 1264px) {
  .product-container {
    max-width: 1129px;
  }
}

@media (min-width: 1879px) {
  .product-container {
    max-width: 1691px;
    margin-left: initial;
  }
}

@media (min-width: 1904px) {
  .product-container {
    max-width: 1556px;
    margin: auto;
  }
}
</style>
